import { MenuItem } from '@material-ui/core'
import { useEffect } from 'react'

import InputText from '@/components/input-text'

import { SearchTypesComponentsProps } from '..'
import { useStyles } from '../styles'

export function TagSearchField({
  value,
  onChange,
}: SearchTypesComponentsProps) {
  const classes = useStyles()

  useEffect(() => {
    onChange('cane')
  }, [])

  return (
    <InputText
      aria-label='Campo de busca por tag'
      value={value}
      onChange={(e) => onChange(e.target.value)}
      select
      SelectProps={{
        MenuProps: {
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          getContentAnchorEl: null,
          classes: { paper: classes.menuList },
          elevation: 0,
        },
      }}
    >
      <MenuItem className={classes.menuItem} value='cane'>
        Cana-de-açúcar
      </MenuItem>
      <MenuItem className={classes.menuItem} value='soybean'>
        Soja
      </MenuItem>
      <MenuItem className={classes.menuItem} value='weed'>
        Daninhas
      </MenuItem>
      <MenuItem className={classes.menuItem} value='planting_failure'>
        Falha de Plantio
      </MenuItem>
    </InputText>
  )
}
